var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-container",
        {
          staticStyle: { "padding-top": "0px" },
          attrs: { id: "main-container", fluid: "", "fill-height": "" }
        },
        [
          _c(
            "v-layout",
            { attrs: { flex: "", "align-center": "", "justify-center": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm12: "", md12: "", lg10: "", xl8: "" } },
                [
                  _c("page-title", {
                    attrs: {
                      title: "Anschrift- und Kontakt-Daten",
                      subtitle:
                        "Haben sich ihre Anschrift- und Kontakt-Daten geändert? Bitte überprüfen Sie die unten angegebenen Daten und korrigieren Sie diese gegebenenfalls"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      model: {
                        value: _vm.formValid,
                        callback: function($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid"
                      }
                    },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            wrap: "",
                            "justify-center": "",
                            "align-right": ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "form-column",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "custom-label-color",
                                attrs: {
                                  label: "Name/Firma",
                                  rules: [
                                    _vm.rules.required,
                                    _vm.rules.maxLength,
                                    _vm.rules.minLength
                                  ]
                                },
                                model: {
                                  value: _vm.form.nameOrCompany,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "nameOrCompany",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.nameOrCompany"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "custom-label-color",
                                attrs: {
                                  label: "Zusatztext",
                                  rules: [_vm.rules.additionalTextMaxLength]
                                },
                                model: {
                                  value: _vm.form.additionalText,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "additionalText",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.additionalText"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "custom-label-color",
                                attrs: {
                                  label: "Straße",
                                  rules: [
                                    _vm.rules.minLength,
                                    _vm.rules.maxLength
                                  ]
                                },
                                model: {
                                  value: _vm.form.street,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "street",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.street"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "custom-label-color",
                                attrs: {
                                  label: "eMail",
                                  rules: [_vm.rules.required, _vm.rules.email]
                                },
                                model: {
                                  value: _vm.form.email,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "email",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c("v-text-field", {
                            staticClass: "custom-label-color",
                            staticStyle: { "padding-right": "8px" },
                            attrs: {
                              label: "L",
                              rules: [_vm.rules.countryMaxLength]
                            },
                            model: {
                              value: _vm.form.country,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "country",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.country"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            staticClass: "custom-label-color",
                            staticStyle: { "padding-right": "8px" },
                            attrs: { label: "PLZ", rules: [_vm.rules.zip] },
                            model: {
                              value: _vm.form.zip,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "zip",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.zip"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            staticClass: "custom-label-color",
                            attrs: {
                              label: "Ort",
                              rules: [_vm.rules.maxLength]
                            },
                            model: {
                              value: _vm.form.city,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "city",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.city"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            wrap: "",
                            "justify-center": "",
                            "align-right": ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "form-column",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "custom-label-color",
                                attrs: {
                                  label: "Telefon (Gesch)",
                                  rules: [
                                    _vm.rules.required,
                                    _vm.rules.telephoneMaxLength
                                  ]
                                },
                                model: {
                                  value: _vm.form.phoneBusiness,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "phoneBusiness",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.phoneBusiness"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "custom-label-color",
                                attrs: {
                                  label: "Telefon (Alterb)",
                                  rules: [_vm.rules.telephoneMaxLength]
                                },
                                model: {
                                  value: _vm.form.phoneAlternative,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "phoneAlternative",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.phoneAlternative"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "custom-label-color",
                                attrs: {
                                  label: "Telefax",
                                  rules: [_vm.rules.telephoneMaxLength]
                                },
                                model: {
                                  value: _vm.form.fax,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "fax",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.fax"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "custom-label-color",
                                attrs: {
                                  label: "Web-Site",
                                  rules: [_vm.rules.webSite]
                                },
                                model: {
                                  value: _vm.form.website,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "website",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.website"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "left-button-container",
                                  attrs: { id: "left", xs6: "", md6: "" }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { id: "form-button" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          $event.preventDefault()
                                          return _vm.goTo()
                                        }
                                      }
                                    },
                                    [_vm._v("Abbruch und Zurück")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "right-button-container",
                                  attrs: { id: "right", xs6: "", md6: "" }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { id: "form-button" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          $event.preventDefault()
                                          return _vm.editUser($event)
                                        }
                                      }
                                    },
                                    [_vm._v("Änderungen übertragen")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.errors.length !== 0
                    ? _c(
                        "v-container",
                        _vm._l(_vm.errors, function(error, index) {
                          return _c(
                            "p",
                            { key: index },
                            [
                              _c(
                                "v-alert",
                                {
                                  attrs: {
                                    value: true,
                                    color: "red darken-2",
                                    icon: "warning",
                                    outline: ""
                                  }
                                },
                                [_vm._v(_vm._s(error))]
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("finished-page-dialog", { ref: "finishedPageDialog" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }